/**
 * Created by user on 2019/6/11.
 */

/**
 * 覆寫函數的 this 類型
 * Overwrite the this type of a function
 */
export type ITSOverwriteThisFunction<T extends any, F extends (...args: any[]) => any> =
	(this: T, ...args: Parameters<F>) => ReturnType<F>
